export const sumMonthlyPayments = (expenses: { monthlyPayment: number }[]) =>
	expenses.reduce((acc, curr) => acc + curr.monthlyPayment, 0);
